var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "el-scrollbar__wrap" }, [
    _c(
      "div",
      { staticClass: "el-scrollbar__view" },
      [
        _c(
          "el-row",
          { staticStyle: { "margin-bottom": "10px" }, attrs: { gutter: 10 } },
          [
            _c(
              "el-col",
              { attrs: { lg: 18, md: 24, sm: 24, xs: 24 } },
              [
                _c(
                  "el-card",
                  { attrs: { header: "活动实时交易情况" } },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { sm: 6, xs: 24 } },
                          [
                            _c("number-info", {
                              attrs: {
                                "sub-title": "今日交易总额",
                                suffix: "元",
                                total: _vm.numeral(124543233).format("0,0"),
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { sm: 6, xs: 24 } },
                          [
                            _c("number-info", {
                              attrs: {
                                "sub-title": "销售目标完成率",
                                total: "92%",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { sm: 6, xs: 24 } },
                          [
                            _c(
                              "number-info",
                              { attrs: { "sub-title": "活动剩余时间" } },
                              [
                                _c("count-down", {
                                  attrs: {
                                    slot: "total",
                                    target: _vm.targetTime,
                                  },
                                  slot: "total",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { sm: 6, xs: 24 } },
                          [
                            _c("number-info", {
                              attrs: {
                                "sub-title": "每秒交易总额",
                                suffix: "元",
                                total: _vm.numeral(234).format("0,0"),
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "map-chart" },
                      [
                        _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: "等待后期实现",
                              placement: "top",
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "https://gw.alipayobjects.com/zos/rmsportal/HBWnDEUXCnGnGrRfrpKa.png",
                                alt: "map",
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { lg: 6, md: 24, sm: 24, xs: 24 } },
              [
                _c(
                  "el-card",
                  {
                    staticStyle: { "margin-bottom": "10px" },
                    attrs: { header: "活动情况预测" },
                  },
                  [_c("active-chart")],
                  1
                ),
                _c(
                  "el-card",
                  { attrs: { header: "券核效率" } },
                  [
                    _c("ve-gauge", {
                      attrs: {
                        height: "200px",
                        series: [
                          {
                            type: "gauge",
                            itemStyle: {
                              color: "#2F9CFF",
                            },
                            splitNumber: 5,
                            radius: "85%",
                            axisLine: {
                              lineStyle: {
                                color: [
                                  [0, "#2F9CFF"],
                                  [80 * 0.01, "#2F9CFF"],
                                  [1, "#F0F2F5"],
                                ],
                                width: 10,
                              },
                            },
                            splitLine: {
                              length: 10,
                            },
                            axisTick: {
                              show: false,
                            },
                            axisLabel: {
                              color: "rgba(0, 0, 0, 0.65)",
                              distance: 8,
                            },
                            pointer: {
                              length: "70%",
                              width: 5,
                            },
                            title: {
                              offsetCenter: [0, "70%"],
                              color: "rgba(0, 0, 0, 0.43)",
                              fontSize: 14,
                            },
                            silent: true,
                            data: [
                              {
                                value: 80,
                                name: "跳出率",
                              },
                            ],
                          },
                        ],
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticStyle: { "margin-bottom": "10px" }, attrs: { gutter: 10 } },
          [
            _c(
              "el-col",
              { attrs: { lg: 9, md: 24, sm: 24, xs: 24 } },
              [
                _c(
                  "el-card",
                  { staticClass: "pie-card", attrs: { header: "各品类占比" } },
                  [
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-progress",
                              { attrs: { type: "circle", percentage: 28 } },
                              [_vm._v("中式快餐")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-progress",
                              { attrs: { type: "circle", percentage: 22 } },
                              [_vm._v("西餐")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-progress",
                              { attrs: { type: "circle", percentage: 32 } },
                              [_vm._v("火锅")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { lg: 9, md: 12, sm: 24, xs: 24 } },
              [
                _c(
                  "el-card",
                  { attrs: { header: "热门搜索" } },
                  [
                    _c("ve-wordcloud", {
                      attrs: {
                        height: "128px",
                        data: {
                          columns: ["word", "count"],
                          rows: [
                            {
                              word: "addidas",
                              count: 2199,
                            },
                            {
                              word: "textStyle",
                              count: 3229,
                            },
                            {
                              word: "markPoint",
                              count: 1857,
                            },
                            {
                              word: "pie",
                              count: 3892,
                            },
                            {
                              word: "roseType",
                              count: 969,
                            },
                            {
                              word: "label",
                              count: 3751,
                            },
                            {
                              word: "emphasis",
                              count: 1205,
                            },
                            {
                              word: "yAxis",
                              count: 7299,
                            },
                            {
                              word: "name",
                              count: 5418,
                            },
                            {
                              word: "type",
                              count: 2290,
                            },
                            {
                              word: "gridIndex",
                              count: 5146,
                            },
                            {
                              word: "normal",
                              count: 4948,
                            },
                            {
                              word: "itemStyle",
                              count: 3837,
                            },
                            {
                              word: "min",
                              count: 4500,
                            },
                            {
                              word: "silent",
                              count: 5744,
                            },
                            {
                              word: "animation",
                              count: 4840,
                            },
                            {
                              word: "parallelAxis",
                              count: 4029,
                            },
                          ],
                        },
                        settings: {
                          shape: "diamond",
                        },
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-col",
              { attrs: { lg: 6, md: 12, sm: 24, xs: 24 } },
              [
                _c(
                  "el-card",
                  { attrs: { header: "资源剩余" } },
                  [
                    _c("ve-liquidfill", {
                      attrs: {
                        height: "126px",
                        series: [
                          {
                            type: "liquidFill",
                            name: "补贴资金剩余",
                            radius: "98%",
                            data: [34 / 100],
                            color: ["#1890FF"],
                            outline: {
                              borderDistance: 0,
                              itemStyle: {
                                borderWidth: 2,
                                borderColor: "#1890ff",
                              },
                            },
                            backgroundStyle: {
                              color: "#fff",
                              borderColor: "#fff",
                              borderWidth: 1,
                            },
                            itemStyle: {
                              opacity: 0.8,
                              shadowBlur: 0,
                            },
                            label: {
                              show: true,
                              color: "rgba(0, 0, 0, 0.43)",
                              fontSize: 28,
                            },
                          },
                        ],
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }